module.exports = __webpack_public_path__ + "img/8629b52fdc50bd24e5d3aa50a40f0d11.ecaca3e8.jpg";